module.exports = __webpack_public_path__ + "img/scroll.60e98a68.gif";